export const GET_ADMIN_USER_ROLES = "GET_ADMIN_USER_ROLES";
export const GET_ADMIN_USER_ROLES_SUCCESS = "GET_ADMIN_USER_ROLES_SUCCESS";
export const GET_ADMIN_USER_ROLES_ERROR = "GET_ADMIN_USER_ROLES_ERROR";

export const CREATE_ADMIN_USER_ROLE = "CREATE_ADMIN_USER_ROLE";
export const CREATE_ADMIN_USER_ROLE_SUCCESS = "CREATE_ADMIN_USER_ROLE_SUCCESS";
export const CREATE_ADMIN_USER_ROLE_ERROR = "CREATE_ADMIN_USER_ROLE_ERROR";

export const UPDATE_ADMIN_USER_ROLE = "UPDATE_ADMIN_USER_ROLE";
export const UPDATE_ADMIN_USER_ROLE_SUCCESS = "UPDATE_ADMIN_USER_ROLE_SUCCESS";
export const UPDATE_ADMIN_USER_ROLE_ERROR = "UPDATE_ADMIN_USER_ROLE_ERROR";

export const DELETE_ADMIN_USER_ROLE = "DELETE_ADMIN_USER_ROLE";
export const DELETE_ADMIN_USER_ROLE_SUCCESS = "DELETE_ADMIN_USER_ROLE_SUCCESS";
export const DELETE_ADMIN_USER_ROLE_ERROR = "DELETE_ADMIN_USER_ROLE_ERROR";

export const RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES = "RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES";
export const ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE = "ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE";
export const ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS = "ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS";
export const ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR = "ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR";